import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationService } from '../../services/notification.service';
export function OnIFrameSave(data) {
}
export function OnIFrameError(error) {
  if (!error) {
    return;
  }
}
@Component({
  selector: 'app-hostedpayment-dialog',
  templateUrl: './hostedpayment-dialog.component.html',
  styleUrls: ['./hostedpayment-dialog.component.scss']
})

export class HostedpaymentDialogComponent implements OnInit {
  public paymentData: any = {};
  public iFrameUrl: any;
  constructor(public sanitizer: DomSanitizer, private elementRef: ElementRef, 
    public http: HttpClient, public dialogRef: MatDialogRef<HostedpaymentDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    public notificationService: NotificationService,) {
    // this.dialogRef.disableClose = true;
    // console.log("datadata",data)
    if(this.data.isCheckout){
      if(this.data?.Script){
        this.paymentData = this.data;
      }
      else{
        this.paymentData = this.data?.IFrameUrl;
      }
    }
    else{
      this.paymentData = this.data?.IFrameUrl;
    }
  }
  @HostListener('window:message', ['$event'])
  onMessage(e) {
    if (!e || !e.data) {
      return;
    }
    
    if (e.data.event == 'cardSaved') {
      this.dialogRef.close({ success: true, data: e.data.data });
      return;
    }
    
    if (e.data.isTestCardEvent == true) {
      this.dialogRef.close({ success: true, data: e.data });
      return;
    }
    
    if (e.data.event === 'processed') {
      this.handleIframeMessage(e);
      return;
    }
    
    if (e.data && (e.data.PaymentMethodId || e.data.Token || e.data.paymentMethodId || e.data.token || e.data.lastFour || e.data.last4)) {
      this.dialogRef.close({ success: true, data: e.data });
      return;
    }
    
    if (this.paymentData.Script && e.data && typeof e.data === 'object' && Object.keys(e.data).length > 0) {
      if (e.data.Status === 'Success' || e.data.status === 'success' || e.data.success === true || 
          e.data.PaymentMethodId || e.data.Token || !e.data.event) {
        this.dialogRef.close({ success: true, data: e.data });
        return;
      }
    }
    
    this.handleIframeMessage(e);
  }
  @HostListener('window:OnIFrameSave', ['$event'])
  OnIFrameSave(e) {
    if (e) {
      this.dialogRef.close({ success: true, data: e });
    } else {
      this.dialogRef.close({ success: true, data: {} });
    }
  }
  @HostListener('window:OnIFrameError', ['$event'])
  OnIFrameError(e) {

  }
  ngOnInit(): void {
    this.setUpIframeMethods();
    //old width="{{getIframeWidth()}}" of iframe, new given 100% for responsive
    // this.executePaymentScripts(this.paymentData.Script);
    // this.iFrameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.paymentData.IFrameUrl);

    if (this.paymentData && this.paymentData.Script) {
      this.executePaymentScripts(this.paymentData.Script);
    }
    if (this.paymentData?.IFrameUrl) {
      this.iFrameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.paymentData.IFrameUrl,
      );
    } else {
      this.iFrameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.paymentData,
      );
    }
  }

  handleIframeMessage(event: MessageEvent) {
    if (!event || !event.data) {
      return;
    }

    if (event.data.action === 'styleButton') {
      const button = document.getElementById('submitButton');
      if (button && event.data.styles) {
        const styles = event.data.styles;
        Object.keys(styles).forEach((style) => {
          button.style[style] = styles[style];
        });

        button.addEventListener('click', () => {
          if (!event.data?.data?.isFormValid) {
            this.notificationService.error(
              "error",
              'Please fill in all required fields correctly.'
            );
            return;
          }
        });
      }
    }

    const loader = this.elementRef.nativeElement.querySelector('#loader');
    const eventData = event.data?.data || event.data;
    const eventType = event.data?.event;
    
    if (eventType === 'submit') {
      if (loader) {
        loader.style.display = 'flex';
      }
    }
    
    if (eventType === 'processed') {
      if (loader) {
        loader.style.display = 'none';
      }
      setTimeout(() => {
        if (window['handleIframeEvent']) {
          window['handleIframeEvent']();
        }
      }, 3000);
      if (eventData) {
        sessionStorage.setItem("customerLoginDetails", JSON.stringify(eventData));
        localStorage.setItem("customerLoginDetails", JSON.stringify(eventData));
      }
      this.dialogRef.close({ success: true, data: eventData });
    }
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
  getIframeHeight(): string {
    // Make the iframe more compact for better UX
    const originalHeight = this.paymentData.Height;
    if (originalHeight) {
      // Convert to number and reduce by 20% for desktop, 10% for mobile
      const heightNum = parseInt(originalHeight);
      if (window.innerWidth > 768) {
        return Math.max(heightNum * 0.8, 400) + 'px'; // Desktop: 80% of original, min 400px
      } else {
        return Math.max(heightNum * 0.9, 350) + 'px'; // Mobile: 90% of original, min 350px
      }
    }
    return '500px'; // Default fallback
  }

  getIframeUrl(): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.paymentData.IFrameUrl);
  }

  getIframeWidth(): string {
    return this.paymentData.Width;
  }


  executePaymentScripts(html) {
    // Extract, load and execute <script src> tags
    // Extract and execute <script> tags with inline javascript

    var externalScripts = this.getExternalScripts(html);
    html = this.removeExternalScriptTags(html);

    this.runExternalScripts(externalScripts).then(() => {
      var inlineScripts = this.getInlineScripts(html);
      this.runInlineScripts(inlineScripts);
    });
  }

  getExternalScripts(html) {
    var externalScriptOpenRegex = /<script[^>]*src="[^"]*"[^>]*>/g;
    var srcAttrRegex = /src="([^"]*)"/;

    var scriptTags = html.match(externalScriptOpenRegex);

    if (!scriptTags) {
      return [];
    }

    return scriptTags.map((tag) => {
      var link = srcAttrRegex.exec(tag);

      if (!link) {
        return null;
      }

      // Index 1 is the first capture group result
      return link[1];
    }).filter(function (link) {
      return !!link;
    });
  }

  getInlineScripts(html) {
    var inlineScriptTagRegex = /<script[^>]*>([\s\S]*)<\/script>/g;
    var scriptTags = html.match(inlineScriptTagRegex);

    if (!scriptTags) {
      return [];
    }

    return scriptTags.map((tag) => {
      var script = inlineScriptTagRegex.exec(tag);

      if (!script) {
        return null;
      }

      // Index 1 is the first capture group result
      return script[1];
    }).filter(function (script) {
      return !!script;
    });
  }

  removeExternalScriptTags(html) {
    var externalScriptRegex = /<script[^>]*src="[^"]*"[^>]*>.*<\/script>/g;
    return html.replace(externalScriptRegex, '');
  }

  runExternalScripts(urlArray) {
    const promise = new Promise((resolve, reject) => {
      var firstScript = urlArray.splice(0, 1)[0];
      if (!firstScript) {
        resolve(true);
        return promise;
      }

      this.http.get<any>(firstScript).subscribe(() => {
        this.runExternalScripts(urlArray);
        resolve(true);
      });
    });
    return promise;
  }
  runInlineScripts(scriptArray) {
    window.eval(scriptArray.join('\n;\n'));
  }
  setUpIframeMethods() {
    const self = this;
    window['OnIFrameSave'] = function(data) {
      if (data) {
        self.dialogRef.close({ success: true, data: data });
      } else {
        self.dialogRef.close({ success: true, data: {} });
      }
    };
    window['OnIFrameError'] = function(error) {
      OnIFrameError(error);
    };
  }
  onload() {
    //this.save(data);
  }
}
